<template>
  <div>
    <h2 class="content-block">
      Ledger Balance for
		{{ gatewayLookup[gateway].sources[source].name }}
    </h2>
    <b-form class="dx-card wide-card form" @submit.stop.prevent="showReport">
      <b-row>
        <b-col>
          <date-range :date-range="dateRange" @dateUpdate="dateUpdate" />
        </b-col>
      </b-row>
      <div>
        {{
          formatTimeByComparisonSource(
            dateRange.startDate.getTime(),
            gateway,
            source,
            true,
          )
        }}
        to
        {{
          formatTimeByComparisonSource(
            dateRange.endDate.getTime(),
			gateway,
			source,
            true,
          )
        }}
      </div>
      <div class="d-flex justify-content-end mt-3">
        <div>
          <b-button
            slot="finish"
            type="submit"
            :disabled="loading"
            variant="primary"
          >
            Show report<span
              v-if="loading"
              class="fa fa-spinner fa-pulse fa-fw ml-2"
            /><span v-else class="fa fa-search fa-fw ml-2" />
          </b-button>
        </div>
      </div>
    </b-form>
    <dx-data-grid
      v-if="dataSource !== null"
      :data-source="dataSource"
      :show-borders="true"
      :remote-operations="false"
      :allow-column-reordering="false"
      :allow-column-resizing="true"
      :row-alternation-enabled="true"
      :hover-state-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="true"
      :show-row-lines="true"
      :show-column-lines="true"
      class="dx-card wide-card"
      width="100%"
    >
      <dx-group-panel :visible="false" />
      <dx-grouping :auto-expand-all="false" />
      <dx-column-chooser :enabled="false" />
      <dx-export :enabled="true" :file-name="`${currentDate}-${$route.name}`" />

      <dx-filter-row :visible="false" />
      <dx-header-filter :visible="false" />
      <dx-filter-panel :visible="false" />
      <dx-column data-field="text" caption="Category" />
      <dx-column data-field="total" format="#,##0.00;(#,##0.00)" />
      <dx-column data-field="matched" format="#,##0.00;(#,##0.00)" />
      <dx-column data-field="inReview" format="#,##0.00;(#,##0.00)" />
      <dx-column data-field="unmatched" format="#,##0.00;(#,##0.00)" />
    </dx-data-grid>
  </div>
</template>

<script>
	import {mapState} from 'vuex'
	import {
		DxColumn,
		DxColumnChooser,
		DxDataGrid,
		DxExport,
		DxFilterPanel,
		DxFilterRow,
		DxGrouping,
		DxGroupPanel,
		DxHeaderFilter,
	} from 'devextreme-vue/data-grid'
	import {DxTagBox} from 'devextreme-vue'
	import {http, showHttpError} from '@/utils/http'
	import DateRange from '@/components/date-range'
	import {config} from '@/config'
	import {formatTimeByComparisonSource} from '../../utils/time'

	export default {
  name: 'ViewStatements',
  components: {
    DateRange,
    DxColumn,
    DxColumnChooser,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxFilterPanel,
    DxGrouping,
    DxGroupPanel,
    DxHeaderFilter,
    // eslint-disable-next-line vue/no-unused-components
    DxTagBox,
  },
  data() {
    return {
      config,
      dataSource: null,
      dateRange: {
        startDate: new Date(new Date().getTime() - 7 * config.oneDay),
        endDate: new Date(),
      },
	  gateway: this.$route.params.gateway,
      source: this.$route.params.source,
      loading: false,
    }
  },
  computed: {
    ...mapState('user', ['gatewayLookup']),
    currentDate() {
      return new Date().toISOString().split('T')[0]
    },
  },
  methods: {
    formatTimeByComparisonSource,
    async showReport() {
      let response
      this.loading = true
      this.dataSource = null
      try {
        response = await http
          .get(
            'reconciliation/admin/accountsReport/' + this.gateway + '/' + this.source,
            {
              searchParams: {
                from: this.dateRange.startDate.getTime(),
                to: this.dateRange.endDate.getTime(),
              },
            },
          )
          .json()
        this.dataSource = response.rows
      } catch (e) {
        return await showHttpError(e)
      } finally {
        this.loading = false
      }
    },
    dateUpdate(dateRange) {
      this.dateRange = Object.assign({}, this.dateRange, dateRange)
    },
  },
}
</script>
<style lang="scss">
td[role='columnheader'] {
  text-align: center !important;
}
</style>
